<div class="container">

  <div class="row">

        <div class="col-lg-12" id="cet">

            <a href="{{ Source.url }}"><img src="{{ Source.imageUrl }}"/></a>
                <h4> {{ Source.name }}</h4>
                <!--<p> {{ Source.description }}</p>-->
                <p>Category: <span class="" style="color: green;">{{ category }}</span></p>
                <p>tags: <span class="" style="color: green;">{{ subcategories }}</span></p>
                <p>Alexa Global Rank: <span class="" style="color: #2d9cdb;">{{ siteRank }} </span></p>
                <p>Featured on <a href="https://rapidapi.com/" style="color: blue;">RapidAPI</a>: No</p>

            <a class="btn btn-info btn-lg mt-4" href="{{ Source.url }}">Visit</a>

        </div>

        <div class="row mt-4">
          <h2>RELATED</h2>
                <div class="col-lg-12" style="margin-bottom: 4px;" *ngFor="let source of otherRelatedSources" >

                      <a routerLink="/payments//platforms/{{ source.slug }}"><img src="{{ source.imageUrl }}" (click)="gotoUrl(source.slug)"/></a>
                          <h4> {{ source.name }}</h4>
                          <!--<p> {{ source.description }}</p>-->
                              <p>An awesome Payment Service Provider </p>


                </div>
                <button class="btn btn-primary col-md-4 mt-4 mb-4" (click)="loadMoreSources()"> Load More</button>

        </div>



  </div>
</div>




